/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedShippingInfoLink_item = {
    readonly hasShipmentQuotes: boolean | null;
    readonly itemIsOnHold: boolean | null;
    readonly hasPrivateListing: boolean | null;
    readonly attributes: {
        readonly leadTime: ReadonlyArray<{
            readonly value: string | null;
        } | null> | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedContactDealerButton_item">;
    readonly " $refType": "PdpSharedShippingInfoLink_item";
};
export type PdpSharedShippingInfoLink_item$data = PdpSharedShippingInfoLink_item;
export type PdpSharedShippingInfoLink_item$key = {
    readonly " $data"?: PdpSharedShippingInfoLink_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedShippingInfoLink_item">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedShippingInfoLink_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userId",
      "type": "String"
    }
  ],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasShipmentQuotes",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": "itemIsOnHold",
      "name": "isOnHold",
      "args": [
        {
          "kind": "Variable",
          "name": "buyerId",
          "variableName": "userId"
        }
      ],
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasPrivateListing",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "attributes",
      "storageKey": null,
      "args": null,
      "concreteType": "ItemAttributes",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "leadTime",
          "storageKey": null,
          "args": null,
          "concreteType": "AttributeValue",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "value",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedContactDealerButton_item",
      "args": null
    }
  ]
};
(node as any).hash = '86b5726e1bf8e578a8ed0a2e0cc73145';
export default node;
